// routes
import { PATH_DASHBOARD, PATH_DASHBOARD_EVENT, PATH_DASHBOARD_SUB } from '../../../routes/paths';
// components
import Iconify from '../../../components/minimal/iconify';
import { ROLES_LABELS } from '../../../pages/common/guards/RoleGuard';

// ----------------------------------------------------------------------

const navConfig = [
  {
    items: [
      {
        title: 'navigation.main',
        path: PATH_DASHBOARD.main,
        icon: <Iconify icon="mage:dashboard-bar-notification" />,
        disableChildIndicator: true,
        activeEndsWithPath: true,
        isSellerRoute: true
      },
      {
        title: 'navigation.calendar',
        path: PATH_DASHBOARD.calendar,
        icon: <Iconify icon="mdi:calendar-today-outline" />,
        disableChildIndicator: true,
        activeEndsWithPath: true,
        isCalendarRoute: true,
      },
      {
        title: 'navigation.cashier',
        path: PATH_DASHBOARD.cashier,
        icon: <Iconify icon="mdi:cash-register" />,
        disableChildIndicator: true,
        activeEndsWithPath: true,
        isCashierRoute: true,
        minimumRoleAllowedAccess: ROLES_LABELS.READER
      },
      {
        title: 'navigation.my_links',
        path: PATH_DASHBOARD.promoter,
        icon: <Iconify icon="tabler:affiliate" />,
        disableChildIndicator: true,
        activeEndsWithPath: true,
        isPromoterRoute: true
      },
      {
        title: 'navigation.system_management',
        disableActive: true,
        icon: <Iconify icon="carbon:id-management" />,
        isSellerRoute: true,
        path: '',
        children: [
          {
            title: 'dashboard.my_leads',
            isCrmRoute: true,
            disableChildIndicator: true,
            isSellerRoute: true,
            path: PATH_DASHBOARD.my_leads,
            icon: <Iconify icon="fluent:person-search-24-regular" />,
          },
          {
            title: 'navigation.my_customers',
            isCrmRoute: true,
            disableChildIndicator: true,
            isSellerRoute: true,
            path: PATH_DASHBOARD.end_users,
            icon: <Iconify icon="fluent:person-money-24-regular" />,
          },
          {
            title: 'my_members.title',
            isCrmRoute: true,
            disableChildIndicator: true,
            isSellerRoute: true,
            path: PATH_DASHBOARD.my_members,
            icon: <Iconify icon="fluent:person-heart-32-regular" />,
          },
          {
            title: 'navigation.group_orders',
            isGroupOrdersRoute: true,
            disableChildIndicator: true,
            isSellerRoute: true,
            path: PATH_DASHBOARD.group_orders,
            icon: <Iconify icon="fluent:people-team-24-regular" />,
          },
          {
            title: 'navigation.my_sellers',
            isMarketPlaceOwnerRoute: true,
            isSellersManagerRoute: true,
            disableChildIndicator: true,
            activeEndsWithPath: true,
            path: PATH_DASHBOARD.sellers,
            icon: <Iconify icon="fluent:person-star-32-regular" />,
          },
          {
            title: 'navigation.customer_club',
            disableChildIndicator: true,
            activeEndsWithPath: true,
            isAllowSeasonTicketRoute: true,
            isSellerRoute: true,
            isCrmRoute: true,
            path: PATH_DASHBOARD.season_ticket,
            icon: <Iconify icon="eva:award-outline" />,
          },
          {
            title: 'navigation.seats_chart_management',
            isMarketPlaceOwnerRoute: true,
            disableChildIndicator: true,
            activeEndsWithPath: true,
            path: PATH_DASHBOARD.seats_chart_admin,
            icon: <Iconify icon="fluent:seat-20-regular" />,
          },
          {
            title: 'navigation.sales_data',
            isMarketPlaceOwnerRoute: true,
            disableChildIndicator: true,
            activeEndsWithPath: true,
            path: PATH_DASHBOARD.market_sale_stats,
            icon: <Iconify icon="mingcute:pig-money-line" />,
          },
          {
            title: 'navigation.sms_sending',
            isSellerRoute: true,
            disableChildIndicator: true,
            activeEndsWithPath: true,
            path: PATH_DASHBOARD.sms_campaign,
            icon: <Iconify icon="material-symbols:sms-outline" />,
          },
          {
            title: 'navigation.legal_settings',
            isMarketPlaceOwnerRoute: true,
            disableChildIndicator: true,
            activeEndsWithPath: true,
            path: PATH_DASHBOARD.legal,
            icon: <Iconify icon="mdi:legal" />,
          },
          {
            title: 'navigation.financial_management',
            isMarketPlaceOwnerRoute: true,
            disableChildIndicator: true,
            activeEndsWithPath: true,
            path: "https://nimi.payme.io",
            icon: <Iconify icon="mdi:bank-outline" />,
          },
        ]
      }
    ]
  },
  {
    subheader: 'navigation.productions_management',
    items: [
      {
        title: 'navigation.choose_production',
        disableChildIndicator: true,
        activeEndsWithPath: true,
        path: PATH_DASHBOARD.sub.root,
        icon: <Iconify icon="carbon:carbon" />,
        minimumRoleAllowedAccess: ROLES_LABELS.READER
      }
    ]
  },
  {
    dependOn: 'subId',
    items: [
      {
        title: '__sub__',
        disableActive: true,
        path: '',
        minimumRoleAllowedAccess: ROLES_LABELS.READER,
        icon: <Iconify icon="carbon:carbon-for-ibm-product" />,
        children: [
          {
            title: 'events',
            disableChildIndicator: true,
            activeEndsWithPath: true,
            path: PATH_DASHBOARD_SUB.EVENT,
            icon: <Iconify icon="circum:grid-3-1" />,
            isAccountRelative: true
          },
          {
            title: 'navigation.production_users',
            disableChildIndicator: true,
            path: PATH_DASHBOARD_SUB.USER,
            icon: <Iconify icon="codicon:organization" />,
            isAccountRelative: true
          },
          {
            title: 'coupons.page_title',
            icon: <Iconify icon="mdi:coupon-outline" />,
            disableChildIndicator: true,
            path: PATH_DASHBOARD_SUB.COUPONS,
            isAccountRelative: true
          },
          {
            title: 'sales_table',
            icon: <Iconify icon="material-symbols:table-chart-view" />,
            disableChildIndicator: true,
            path: PATH_DASHBOARD_SUB.SALES_TABLE,
            isAccountRelative: true
          },
          // TODO: add configurations here
          {
            title: 'navigation.production_settings',
            isAccountRelative: true,
            disableChildIndicator: true,
            path: PATH_DASHBOARD_SUB.PRODUCTION_SETTINGS,
            icon: <Iconify icon="eva:settings-2-outline" />,
          },
        ]
      },
    ]
    //
  },
  // EVENT MANAGEMENT
  // ----------------------------------------------------------------------
  {
    dependOn: 'eventId', // display this links only when 'eventId' on the useParams returns object
    subheader: 'navigation.event_management',
    items: [
      {
        title: 'event_sale_stats',
        isRelative: true,
        path: PATH_DASHBOARD_EVENT.SELL_STATS,
        icon: <Iconify icon="mdi:dollar" />,
      },
      {
        title: 'edit_event',
        path: PATH_DASHBOARD_EVENT.EDIT,
        isRelative: true,
        icon: <Iconify icon="eva:edit-outline" />,
      },
      {
        title: 'navigation.event_settings',
        isRelative: true,
        path: PATH_DASHBOARD_EVENT.SETTINGS,
        icon: <Iconify icon="eva:settings-2-outline" />,
      },
      {
        title: 'navigation.coupons',
        path: PATH_DASHBOARD_EVENT.COUPONS,
        isRelative: true,
        icon: <Iconify icon="mdi:coupon-outline" />,
      },
      {
        title: 'navigation.free_tickets',
        path: PATH_DASHBOARD_EVENT.FREE_TICKETS,
        isRelative: true,
        icon: <Iconify icon="mdi:ticket-confirmation-outline" />,
      },
      {
        title: 'navigation.season_tickets_discount',
        path: PATH_DASHBOARD_EVENT.SEASON_TICKETS_DISCOUNT,
        isRelative: true,
        icon: <Iconify icon="streamline:subscription-cashflow" />,
      },
      {
        title: 'event_orders',
        path: PATH_DASHBOARD_EVENT.ORDERS,
        isRelative: true,
        icon: <Iconify icon="eva:people-outline" />,
      },
      {
        title: 'event_links',
        path: PATH_DASHBOARD_EVENT.LINKS,
        isRelative: true,
        icon: <Iconify icon="eva:link-2-outline" />,
      },
      {
        title: 'navigation.seats_chart',
        path: PATH_DASHBOARD_EVENT.SEATS_CHART,
        isRelative: true,
        icon: <Iconify icon="material-symbols:event-seat-outline" />,
      }, {
        title: 'tickets',
        path: PATH_DASHBOARD_EVENT.TICKETS,
        isRelative: true,
        icon: <Iconify icon="mdi:ticket" />,
      }, {
        title: 'navigation.time_slots',
        path: PATH_DASHBOARD_EVENT.TIME_SLOTS,
        isRelative: true,
        icon: <Iconify icon="mdi:clock-outline" />,
      },
    ],
  }
];

export default navConfig;
